// extracted by mini-css-extract-plugin
module.exports = {"offsiteLink":"offsite-link_offsiteLink__v0ZRd"};